// Templates for AJ "Laporan Tindakan" (stored in complaints.aj_report_notes).
// Generated from Zoho export: KES - REKOD KESELURUHAN - LAPORAN TINDAKAN ZOHO.csv

import templates from './laporanTindakanTemplates.json';

export const LAPORAN_TINDAKAN_TEMPLATES = templates;
export default templates;

